module.exports = __webpack_public_path__ + "img/map_en.1622ae88.webp";